var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Community Contact"}}),_c('div',{staticClass:"container-fluid"},[_c('contact-detail',{attrs:{"contactId":_vm.$route.params.contactId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }